export class LoginByTokenModel {
	public accessToken: string;
	public refreshToken: string;
	public userType: string;
	public name: string;
	public email: string;
	public id: string;
	public lang: string;
	public roles: string[];
	public proxy: boolean;
	public proxyName: string;

	public convert(dto: any): LoginByTokenModel {
		if (dto.accessToken) {
			this.accessToken = dto.accessToken;
		}
		if (dto.refreshToken) {
			this.refreshToken = dto.refreshToken;
		}
		if (dto.userType) {
			this.userType = dto.userType;
		}
		if (dto.name) {
			this.name = dto.name;
		}
		if (dto.id) {
			this.id = dto.id;
		}
		if (dto.lang) {
			this.lang = dto.lang;
		}
		if (dto.roles) {
			this.roles = dto.roles;
		}
		if (dto.proxy) {
			this.proxy = dto.proxy;
		}
		if (dto.proxyName) {
			this.proxyName = dto.proxyName;
		}

		return this;
	}

	public storeAuthToLocalStorage(data: LoginByTokenModel) {
		localStorage.setItem('EMRAdmin.accessToken', data.accessToken);
		localStorage.setItem('EMRAdmin.refreshToken', data.refreshToken);
		localStorage.setItem('EMRAdmin.userType', data.userType);
		localStorage.setItem('EMRAdmin.name', data.name);
		localStorage.setItem('EMRAdmin.id', data.id);
		localStorage.setItem('EMRAdmin.lang', data.lang);
		localStorage.setItem('EMRAdmin.roles', JSON.stringify(data.roles));
		localStorage.setItem(
			'EMR.leadShift',
			JSON.stringify({
				proxy: data.proxy,
				proxyName: data.proxyName,
			})
		);
	}
}
